export default __webpack_public_path__ + "static/media/rules_income.cdba4869.svg";